/**
 * Capgo OTA app ready notification - MUST be imported FIRST in main.tsx
 *
 * This module calls notifyAppReady() immediately when JavaScript loads,
 * BEFORE React initialization. This is critical because:
 *
 * 1. Capgo has a timeout (appReadyTimeout in capacitor.config.ts) to receive this signal
 * 2. If not called in time, Capgo assumes the update failed and rolls back
 * 3. By calling before React, we ensure the signal is sent even if React crashes
 *
 * On web this is a no-op (see capacitor-updater web.ts).
 */
import { CapacitorUpdater } from '@capgo/capacitor-updater';

import { logger } from '@/features/logging/service/logger';

logger.info('[Capgo] notifyAppReady called before React initialization');
void CapacitorUpdater.notifyAppReady();
